import { inject } from '@angular/core';
import { Router, type CanActivateFn } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { StripeService } from '../services/stripe.service';
import { of } from 'rxjs';
import { take, timeout, map, switchMap, catchError } from 'rxjs/operators';

export const subscriptionGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const authService = inject(AuthService);
  const stripeService = inject(StripeService);

  // resolvedUser$ waits for Firebase to restore the session (BUG-6).
  return authService.resolvedUser$.pipe(
    take(1),
    timeout(10000),
    switchMap(user => {
      if (!user) {
        router.navigate(['/auth'], { queryParams: { returnUrl: state.url } });
        return of(false);
      }
      if (user.claims?.roles?.includes('admin')) {
        return of(true);
      }
      return stripeService.getCurrentUserSubscriptions(user).pipe(
        take(1),
        timeout(5000),
        map(subscriptions => {
          const hasActive = subscriptions.some(sub =>
            sub.status === 'active' || sub.status === 'trialing'
          );
          if (!hasActive) {
            router.navigate(['/pricing'], { queryParams: { returnUrl: state.url, reason: 'subscription' } });
          }
          return hasActive;
        })
      );
    }),
    catchError(error => {
      console.error('Subscription guard: Error checking access:', error);
      router.navigate(['/pricing'], { queryParams: { returnUrl: state.url, reason: 'unverified' } });
      return of(false);
    })
  );
};
